import type {Plan} from "../store/plansSlice";
import type {ChipTone} from "../theme/tokens";

const PAID_PLAN_TONES: ChipTone[] = ["info", "success", "exclusive"];

/** Chip colour for a plan: purchasable paid plans by ascending base price; everything else neutral. */
export function planTone(planId: string, plans: Plan[]): ChipTone {
    const paidPlans = plans
            .filter((plan) => plan.customerCanPurchase && plan.monthlyBasePriceInCents > 0)
            .sort((a, b) => a.monthlyBasePriceInCents - b.monthlyBasePriceInCents);
    const rank = paidPlans.findIndex((plan) => plan.id === planId);
    if (rank < 0) return "neutral";
    return PAID_PLAN_TONES[Math.min(rank, PAID_PLAN_TONES.length - 1)];
}
